import React from 'react';

import { cn } from '@/lib/cn';

import { PropertyType } from '../model/types';

type PropertyProps = {
    label?: string;
    type?: PropertyType;
    value: React.ReactNode;
    className?: string;
    isInline?: boolean;
};
export const Property = ({
    label,
    value,
    className,
    isInline = false,
}: PropertyProps) => {
    return (
        <dl
            className={cn(className, {
                'flex flex-wrap gap-x-2': !isInline,
            })}
        >
            {label && (
                <dt
                    className={cn('whitespace-nowrap', {
                        'mr-2 inline': isInline,
                    })}
                >
                    {label}:
                </dt>
            )}
            <dd className={cn('font-bold', { inline: isInline })}>{value}</dd>
        </dl>
    );
};
